import { render, staticRenderFns } from "./PostReport.vue?vue&type=template&id=4c5bab8a&scoped=true"
import script from "./PostReport.vue?vue&type=script&lang=js"
export * from "./PostReport.vue?vue&type=script&lang=js"
import style0 from "./PostReport.vue?vue&type=style&index=0&id=4c5bab8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5bab8a",
  null
  
)

export default component.exports